export const formatDateTime = (value?: string | Date) => {
    if (!value) return "-";

    const date = value instanceof Date ? value : new Date(value);

    if (isNaN(date.getTime())) return "-";

    return date.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};

export const TableDisponibilidadeFrota = [
    {
        nomeColuna: "Placa",
        field: "placa",
    },
    {
        nomeColuna: "Eixos",
        field: "numeroEixos",
    },
    {
        nomeColuna: "Tipo Veículo",
        field: "tipoVeiculo",
    },
    {
        nomeColuna: "Tipo Carroceria",
        field: "tipoCarroceria",
    },
    {
        nomeColuna: "Proprietário",
        field: "proprietario",
    },
    {
        nomeColuna: "Motorista",
        field: "motorista",
        link: true
    },
    {
        nomeColuna: "Telefone",
        field: "telefoneMotorista",
    },
    {
        nomeColuna: "Cidade Motorista",
        field: "enderecoMotorista",
    },
    {
        nomeColuna: "Ano Cavalo",
        field: "anoCavalo"
    },
    {
        nomeColuna: "Ano Carreta",
        field: "anoCarreta"
    },
    {
        nomeColuna: "Data Último Carregamento",
        field: "dataUltimoCarregamento",
    },
    {
        nomeColuna: "Data Próxima Viagem no Período",
        field: "dataProximaViagemNoPeriodo",
    },
    {
        nomeColuna: "Data Próxima Viagem Agendada no Período",
        field: "dataProximaViagemAgendadaNoPeriodo",
    },
]